// Testimonials data — Google Reviews curated for L'Atelier Loraine B
// Update GOOGLE_REVIEWS_URL with the real Google Maps/Business link
export const GOOGLE_REVIEWS_URL = "https://share.google/gJReGOaygQjmV6wcz";
export const GOOGLE_REVIEWS_COUNT = 33;
export const GOOGLE_REVIEWS_AVG = "5,0";

export const testimonials = [
  {
    id: "ap",
    name: "A. P.",
    rating: 5,
    color: "#FFD6C9",
    text: "Les cours de danse avec Loraine font partie des moments lumineux de ma semaine ! Loraine est une personne chaleureuse, naturelle, créative, riche de la pratique de plusieurs disciplines artistiques (danse, musique, théâtre) et elle insuffle tout cela dans ses cours. On y danse, d'accord, mais aussi, on s'y découvre et on s'y exprime. À l'intérieur de la « structure » chorégraphique qu'elle propose (avec des chorégraphies très habitées !), Loraine invite chacun et chacune à interpréter « à sa façon », avec son propre style, et elle accueille chaque proposition, chaque façon d'être, chaque énergie, avec un enthousiasme stimulant et contagieux qui fait vraiment du bien ! Loraine vous pousse tout en douceur à faire sortir le petit artiste en vous — et il y a un peu de maïeutique dans tout ça... Alors venez juste comme vous êtes, vous serez entre de très bonnes mains !",
  },
  {
    id: "tiphaine",
    name: "Tiphaine Cosmao",
    rating: 5,
    color: "#C4F4E4",
    text: "Loraine est une prof de danse au top ! Rigoureuse, drôle et rayonnante, elle sait s'adapter à tous les niveaux et nous aide toujours à progresser. Ses cours sont dynamiques et motivants, on apprend, on évolue, et surtout, on passe un super moment avec elle !",
  },
  {
    id: "camille",
    name: "Camille Heckly",
    rating: 5,
    color: "#E6D7FF",
    text: "Si vous souhaitez muscler les zygomatiques pour préparer le faciès summer, allez rencontrer latb ! En prime, vous aurez aussi l'occasion de découvrir votre propre créativité et développer votre style pour donner un peu de pep's au quotidien !!! N'hésitez pas, il n'y a qu'un pas pour danser avec la vie.",
  },
  {
    id: "amine",
    name: "Amine Jbilou",
    rating: 5,
    color: "#FFF3B0",
    text: "J'ai eu la chance de suivre plusieurs ateliers avec Loraine cette année, mais aussi les années précédentes, et d'avoir également l'occasion de la voir sur scène. Loraine est une pédagogue patiente, bienveillante et très à l'écoute. Grâce à elle, j'ai beaucoup appris sur les techniques de l'improvisation, mais aussi sur la confiance en soi, l'écoute des autres et le plaisir de jouer. Son approche permet à chacun de progresser à son rythme dans un cadre à la fois exigeant et encourageant. Une excellente formatrice et une artiste inspirante que je recommande sans hésitation.",
  },
  {
    id: "audrey",
    name: "Audrey Alcibar",
    rating: 5,
    color: "#C9E8FF",
    text: "Très bonne expérience pour ma fille de 10 ans cette année. Elle qui avait gardé un mauvais souvenir d'un enseignement un peu trop ferme avec un autre professeur par le passé, c'est avec entrain qu'elle se rend au cours de Loraine chaque mercredi. De la pédagogie, de la douceur, pas de pression, du plaisir, une liberté d'expression et une confiance en soi retrouvée !",
  },
  {
    id: "celine",
    name: "Céline Adam",
    rating: 5,
    color: "#FFD1DC",
    text: "Tu ne te contentes pas d'enseigner la danse et le théâtre, tu fais naître des émotions, tu racontes des histoires et tu révèles des personnalités. Tu sais faire ressortir le meilleur de nous grâce à cette confiance que tu fais pousser en nous. Merci pour cette belle magie que tu partages avec tant de générosité et de bienveillance.",
  },
  {
    id: "sylvie",
    name: "Sylvie Parvole",
    rating: 5,
    color: "#FFD6C9",
    text: "Une artiste complète qui nous fait partager son expérience de la scène tant en improvisation théâtrale, qu'en danse et comédie musicale avec bienveillance, humanité, compétences et pédagogie. Que du bonheur, un enseignement de grande qualité. Courez-y !",
  },
  {
    id: "mooncake",
    name: "Mooncake",
    rating: 5,
    color: "#C4F4E4",
    text: "Des cours riches avec une super prof qui vous encourage et vous aide à vous dépasser ✨",
  },
];
